import { Editor } from 'slate';
/**
 * Returns parent "list" node of "list-item" at a given path.
 * Returns null if there is no parent "list".
 */
export function getParentList(editor, path) {
  var parentList = Editor.above(editor, {
    at: path,
    match: node => editor.isListNode(node)
  });
  return parentList !== null && parentList !== void 0 ? parentList : null;
}